import React from 'react'
import CodeBlock from '../Code';
const OcrDescription = () => {
    return (
        <>
        <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>광학 문자 인식(OCR) API 사용하기</h3>
          <p>광학 문자 인식(OCR) API를 사용하기 위해 다음 URI를 POST방식으로 호출해야 합니다.</p>
          <CodeBlock
          code ={         "                 /ocr/predict"}
          >
          </CodeBlock>
          <p>
          API 사용시 발급받은 API Key 정보를 요청 헤더에 포함시켜야 합니다. 다음은 요청 헤더 예입니다.
          </p>
          <CodeBlock
          code={`
          [HTTP Request Header]
           
          {
              "Content-Type": "application/json; charset=UTF-8",
              "x-ncp-apigw-api-key": accessKey,
          }`}>

          </CodeBlock>
          <p>위와 같이 HTTP 요청을 API 서버로 전달하면 API 서버는 JSON 형태의 텍스트 데이터를 응답합니다. 다음은 HTTP 응답 예제입니다.</p>
          <CodeBlock
          code={`
          [HTTP Response Body]
           
          {
              "mime": "image/png",
              "data" : {객체검출 결과 JSON},
              "image" : 결과 이미지 Base64(요청 본문 파라미터 return_img가 True 일 경우에만 값이 있음)                                           }
          `}>

          </CodeBlock>
        </div>                      
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Request</h3>
          <p>광학 문자 인식(OCR) API에 필요한 요청 헤더에 다음과 같은 파라미터를 작성해야 합니다.</p>
          <CodeBlock
          code ={         `
          [HTTP Request Header]
          {
                          "Content-Type": "application/json; charset=UTF-8",
                          "x-ncp-apigw-api-key": accessKey,
          },`}
          >
          </CodeBlock>
          <p>
          광학 문자 인식(OCR) API에 필요한 요청 본문에 다음과 같은 파라미터를 작성해야 합니다.
          </p>
          <CodeBlock
          code={`
          [HTTP Request Body]
          {
                  "image": "Your_file",
                  "return_img" : True/False,
          }`}>
          </CodeBlock>
          <p>다음은 요청 본문 파라미터에 대한 설명입니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">Field</th>
                  <th scope="col">Type</th>
                  <th scope="col">필수여부</th>
                  <th scope="col">설명</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>image</td>
                  <td>String</td>
                  <td>O</td>
                  <td>객체검출 하고자 하는 이미지(Base64 문자열만 가능)</td>
                </tr>
                <tr>
                  <td>return_img</td>
                  <td>Boolean</td>
                  <td>X</td>
                  <td>객체검출 후 바운딩박스가 그려진 이미지 반환 여부</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>                      
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>Response</h3>
          <p>광학 문자 인식(OCR) API는 분석된 결과를 JSON 으로 반환합니다.</p>
          <p>다음은 정상적인 요청 처리에 대한 HTTP 응답 예입니다.</p>
          <CodeBlock
          code ={         `
        
              [HTTP Response Body]
              {
                      "mime": "image/png",
                      "data" : {객체검출 결과 JSON},
                      "image" : 결과 이미지 Base64(요청 본문 파라미터 return_img가 True 일 경우에만 값이 있음)                                           }
              `}
          >
          </CodeBlock>
          <p>
          다음은 오류가 발생한 요청 처리에 대한 HTTP 응답 예입니다.
          </p>
          <CodeBlock
          code={`

          [HTTP Response Body]
          {
                  "error": {
                          "errorCode": "210",
                          "message": "Permission Denied",
                          "details": 오류 메세지                                                   }
          }`}>
          </CodeBlock>
          <p>응답 본문의 분석된 결과 “data(JSON)”는 다음과 같은 내용으로 이루어져 있습니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">JSON key</th>
                  <th scope="col">설명</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>data</td>
                  <td></td>
                </tr>
                <tr>
                  <td> - confidence</td>
                  <td>신뢰 점수</td>
                </tr>
                <tr>
                  <td> - x</td>
                  <td>top_left x좌표</td>
                </tr>
                <tr>
                  <td> - y</td>
                  <td>top_left y좌표</td>
                </tr>
                <tr>
                  <td> - width</td>
                  <td>넓이</td>
                </tr>
                <tr>
                  <td> - height</td>
                  <td>길이</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive">
            <p>광학 문자 인식(OCR)이 제대로 이루어지지 않았을 경우에는 결과 대신 오류 메세지가 반환됩니다.</p>
              <table class="table table-bordered">
                <thead>
                  <tr class="table-secondary">
                    <th scope="col">오류 메세지</th>
                    <th scope="col">설명</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>This file is not image content</td>
                    <td>입력된 파일이 실제 이미지 파일이 아닐 경우 </td>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>                      
      </div>
      <div className="row sercice-details-content pb--80 align-items-center">
        <div className="col-12 mx-3">
          <h3>오류코드</h3>
          <p>광학 문자 인식(OCR) API의 오류 목록은 다음과 같습니다.</p>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="table-secondary">
                  <th scope="col">http status</th>
                  <th scope="message">message</th>
                  <th scope="col">detail</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>210 </td>
                  <td>Permission Denied </td>
                  <td>유효하지 않은 API Key </td>
                </tr>
                <tr>
                  <td>420</td>
                  <td>Field required </td>
                  <td>Field required </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>                      
      </div>
      </>
    )
}
export default OcrDescription;